import ResponsiveHelper from '../lib/ResponsiveHelper';
import TouchNav from '../lib/TouchNav';
import '../lib/MobileNav';

export default class JqueryCode {
	constructor($) {
		// init Mobile Nav
		ResponsiveHelper.addRange({
			'..1024': {
				on() {
					$('body').mobileNav({
						menuActiveClass: 'nav-active',
						menuOpener: '.nav-opener',
						hideOnClickOutside: true,
						menuDrop: '#nav',
					});
				},
				off() {
					$('body').mobileNav('destroy');
				},
			},
		});

		// init Mobile Nav Lang
		ResponsiveHelper.addRange({
			'..1024': {
				on() {
					$('body').mobileNav({
						menuActiveClass: 'lang-active',
						menuOpener: '.lang-opener',
						hideOnClickOutside: true,
						menuDrop: '#lang',
					});
				},
				off() {
					$('body').mobileNav('destroy');
				},
			},
		});

		// handle dropdowns on mobile devices
		$('#nav').each(function () {
			new TouchNav({
				navBlock: this,
			});
		});
	}
}
